import { render, staticRenderFns } from "./CheckboxItem.vue?vue&type=template&id=07e62e72&scoped=true&"
import script from "./CheckboxItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e62e72",
  null
  
)

export default component.exports